import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { message } from "antd";

// asymptomatic study
import PersonalInfo from "./screens/basicdetails/PersonalInfo";
import GenderInfo from "./screens/basicdetails/GenderInfo";
import LanguageEducation from "./screens/basicdetails/LanguageEducation";
import PhysicalCharachteristics from "./screens/basicdetails/PhysicalCharachteristics";
import MedicalHistory from "./screens/basicdetails/MedicalHistory";
import MedicalConditions from "./screens/basicdetails/MedicalConditions";
import FamilyHistory from "./screens/basicdetails/FamilyHistory";
import AdditionalHealthInfo from "./screens/basicdetails/AdditionalHealthInfo";
import RecentHealthEvents from "./screens/basicdetails/RecentHealthEvents";
import GeneticTesting from "./screens/basicdetails/GeneticTesting";
import ConsentFormChild from "./screens/basicdetails/ConsentFormChild";

// ecas study
import EcasPersonalInfo from "./screens/ecasBasicDetails/PersonalInfo";
import EcasGenderInfo from "./screens/ecasBasicDetails/GenderInfo";
import EcasLanguageEducation from "./screens/ecasBasicDetails/LanguageEducation";
import EcasPhysicalCharachteristics from "./screens/ecasBasicDetails/PhysicalCharachteristics";
import EcasMedicalHistory from "./screens/ecasBasicDetails/MedicalHistory";
import EcasMedicalConditions from "./screens/ecasBasicDetails/MedicalConditions";
import EcasFamilyHistory from "./screens/ecasBasicDetails/FamilyHistory";
import EcasAdditionalHealthInfo from "./screens/ecasBasicDetails/AdditionalHealthInfo";
import EcasRecentHealthEvents from "./screens/ecasBasicDetails/RecentHealthEvents";
import EcasGeneticTesting from "./screens/ecasBasicDetails/GeneticTesting";
import EcasConsentFormChild from "./screens/ecasBasicDetails/ConsentFormChild";
import EcasSymptomOnsetForm from "./screens/ecasBasicDetails/SymptomOnsetForm";

import SpeechConsentFormChild from "./screens/speech/demographicsComponents/ConsentFormChild";
// speech study
import SpeechNonAlsUsers from "./screens/speech/demographicsComponents/NonAlsUsersForm";
import SpeechDateOfBirth from "./screens/speech/demographicsComponents/DateOfBirthForm";
import SpeechEthnicityRace from "./screens/speech/demographicsComponents/EthnicityRaceForm";
import SpeechLanguageAndEducation from "./screens/speech/demographicsComponents/LanguageAndEducationForm";
import SpeechHandnessSmokingHistory from "./screens/speech/demographicsComponents/HandnessSmokingHistoryForm";
import SpeechAllergiesAndPrescriptions from "./screens/speech/demographicsComponents/AllergiesAndPrescriptionsForm";
import SpeechMedicalHistory from "./screens/speech/demographicsComponents/MedicalHistoryForm";
import SpeechDiagnosis from "./screens/speech/demographicsComponents/DiagnosisForm";
import SpeechSymptomOnset from "./screens/speech/demographicsComponents/SymptomOnsetForm";
import SpeechFamilyHistory from "./screens/speech/demographicsComponents/FamilyHistoryForm";

// LE Study
import LEConsentFormChild from "./screens/leStudy/demographicsComponents/ConsentFormChild";

// als
import LEAlsPersonalInfo from "./screens/leStudy/demographicsComponents/als/PersonalInfo";
import LEAlsSymptomOnsetForm from "./screens/leStudy/demographicsComponents/als/SymptomOnsetForm";
import LEAlsGenderInfo from "./screens/leStudy/demographicsComponents/als/GenderInfo";
import LEAlsLanguageEducation from "./screens/leStudy/demographicsComponents/als/LanguageEducation";
import LEAlsMedicalHistory from "./screens/leStudy/demographicsComponents/als/MedicalHistory";

// controls
import LEControlsPersonalInfo from "./screens/leStudy/demographicsComponents/controls/PersonalInfo";
import LEControlsGenderInfo from "./screens/leStudy/demographicsComponents/controls/GenderInfo";
import LEControlsLanguageEducation from "./screens/leStudy/demographicsComponents/controls/LanguageEducation";
import LEControlsMedicalHistory from "./screens/leStudy/demographicsComponents/controls/MedicalHistory";

import { RESEARCH_TYPE } from "./utils/consts";

import englishJson from './utils/language/leStudy/english.json';
import spanishJson from './utils/language/leStudy/spanish.json';
import noLanguageJson from './utils/language/leStudy/noLanguage.json';
import Bridge from "./utils/Bridge";

export default class ConsentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_step: "0",
      is_non_als_user: false,
      language: "Spanish",
    };
  }
  componentDidMount(){
    console.log('language', this.props.language);
  }
  selectUserType = (param) => {
    this.setState({
      active: param,
    });
  };
  continue = () => {
    if (!this.state.active) {
      message.warning("Please select account");
      return;
    }
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  set_active_step = (step) => {
    this.setState({ active_step: step });
  };
  set_non_als_user = (value) => {
    this.setState({ is_non_als_user: value });
  };
  render() {
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  {this.state.active_step != "0" && (
                    <a href="/dashboard" className="back-arrow width-fit-content">
                      <box-icon
                        name="chevron-left"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                      {formData.page.backButtonTextDashboard}
                    </a>
                  )}
                  {RESEARCH_TYPE == "modality.ai" && (
                    <>
                      {this.state.active_step == "0" && (
                        <SpeechConsentFormChild
                          set_active_step={this.set_active_step}
                          is_update={false}
                          set_non_als_user={this.set_non_als_user}
                        />
                      )}
                      {this.state.active_step == "1" && (
                        <SpeechNonAlsUsers
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "2" && (
                        <SpeechDateOfBirth
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "3" && (
                        <SpeechEthnicityRace
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "4" && (
                        <SpeechLanguageAndEducation
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "5" && (
                        <SpeechHandnessSmokingHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "6" && (
                        <SpeechAllergiesAndPrescriptions
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "7" && (
                        <SpeechMedicalHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                          is_non_als_user={this.state.is_non_als_user}
                        />
                      )}
                      {this.state.active_step == "8" && (
                        <SpeechDiagnosis
                          set_active_step={this.set_active_step}
                          is_update={false}
                          is_non_als_user={this.state.is_non_als_user}
                        />
                      )}
                      {this.state.active_step == "9" && (
                        <SpeechSymptomOnset
                          set_active_step={this.set_active_step}
                          is_update={false}
                          is_non_als_user={this.state.is_non_als_user}
                        />
                      )}
                      {this.state.active_step == "10" && (
                        <SpeechFamilyHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                    </>
                  )}
                  {RESEARCH_TYPE == "Asymptomatic Study" && (
                    <>
                      {this.state.active_step == "0" && (
                        <ConsentFormChild
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "1" && (
                        <PersonalInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "2" && (
                        <GenderInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "3" && (
                        <LanguageEducation
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "4" && (
                        <PhysicalCharachteristics
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "5" && (
                        <MedicalHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "6" && (
                        <FamilyHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "7" && (
                        <AdditionalHealthInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "8" && (
                        <RecentHealthEvents
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "9" && (
                        <GeneticTesting
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                    </>
                  )}
                  {RESEARCH_TYPE == "ECAS Study" && (
                    <>
                      {this.state.active_step == 0 && (
                        <EcasConsentFormChild
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 1 && (
                        <EcasPersonalInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 2 && (
                        <EcasSymptomOnsetForm
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 3 && (
                        <EcasGenderInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 4 && (
                        <EcasLanguageEducation
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 5 && (
                        <EcasPhysicalCharachteristics
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 6 && (
                        <EcasMedicalHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}

                      {this.state.active_step == 7 && (
                        <EcasFamilyHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 8 && (
                        <EcasAdditionalHealthInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                    </>
                  )}
                  {RESEARCH_TYPE == "LE Study" && (
                    <>
                      {this.state.active_step == "0" && (
                        <LEConsentFormChild
                          set_active_step={this.set_active_step}
                          is_update={false}
                          set_non_als_user={this.set_non_als_user}
                          language={this.props.language}
                        />
                      )}
                      {this.state.active_step == 1 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                          "Healthy control" ? (
                            <LEControlsPersonalInfo
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          ) : (
                            <LEAlsPersonalInfo
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                      {this.state.active_step == 2 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                            "Living with ALS" && (
                            <LEAlsSymptomOnsetForm
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                      {this.state.active_step == 3 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                          "Healthy control" ? (
                            <LEControlsGenderInfo
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          ) : (
                            <LEAlsGenderInfo
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                      {this.state.active_step == 4 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                          "Healthy control" ? (
                            <LEControlsLanguageEducation
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          ) : (
                            <LEAlsLanguageEducation
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                      {this.state.active_step == 5 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                          "Healthy control" ? (
                            <LEControlsMedicalHistory
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          ) : (
                            <LEAlsMedicalHistory
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
